import Store from 'types/Store/CashieringStore';

export const getNewFolioId = (state: Store) => state.cashiering.newFolioId;
